import React from "react";
import Mandala from "./Mandala";

const SHANKA_URL =
  require("../../assets/x0a4p375_shanka_gold-removebg-preview.png");
const CHAKRA_URL =
  require("../../assets/5uvd55g4_chakra_gold-removebg-preview.png");

/**
 * PageBackground - fixed, non-interactive spiritual decor for every page.
 * Layers:
 *  1. A subtle kolam/rangoli repeating tile applied via bg-ivory-texture
 *     on the PageLayout root.
 *  2. Four large mandalas softly anchored to viewport corners.
 *  3. Sacred Shanka (conch) + Chakra (discus) motifs on left/right flanks.
 *  4. A large central golden radial glow to give warmth.
 * All layers use very low opacity so content remains fully readable.
 */
const PageBackground = () => {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-0 overflow-hidden"
      data-testid="page-background"
    >
      {/* Central warm glow */}
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        style={{
          width: "80vmax",
          height: "80vmax",
          background:
            "radial-gradient(circle, rgba(212,175,55,0.06) 0%, rgba(212,175,55,0.02) 40%, transparent 70%)",
        }}
      />

      {/* Top-left mandala */}
      <div
        className="absolute -top-40 -left-40 animate-mandala-slow"
        style={{ opacity: 0.12 }}
      >
        <Mandala size={520} color="#B65A14" opacity={1} />
      </div>

      {/* Top-right mandala */}
      <div
        className="absolute -top-32 -right-40 animate-mandala-reverse"
        style={{ opacity: 0.12 }}
      >
        <Mandala size={460} color="#D4AF37" opacity={1} />
      </div>

      {/* Bottom-left mandala */}
      <div
        className="absolute -bottom-48 -left-32 animate-mandala-reverse"
        style={{ opacity: 0.1 }}
      >
        <Mandala size={500} color="#D4AF37" opacity={1} />
      </div>

      {/* Bottom-right mandala */}
      <div
        className="absolute -bottom-40 -right-40 animate-mandala-slow"
        style={{ opacity: 0.12 }}
      >
        <Mandala size={560} color="#B65A14" opacity={1} />
      </div>

      {/* Sacred Shanka - upper-left flank (large, upright, subtle) */}
      <img
        src={SHANKA_URL}
        alt=""
        className="absolute hidden sm:block select-none"
        style={{
          top: "14vh",
          left: "-3vw",
          width: "clamp(200px, 20vw, 320px)",
          opacity: 0.14,
        }}
      />

      {/* Sacred Shanka - mid-right (mirrored) */}
      <img
        src={SHANKA_URL}
        alt=""
        className="absolute hidden sm:block select-none"
        style={{
          top: "62vh",
          right: "-4vw",
          width: "clamp(190px, 18vw, 300px)",
          opacity: 0.13,
          transform: "scaleX(-1)",
        }}
      />

      {/* Sacred Chakra - bottom-left */}
      <img
        src={CHAKRA_URL}
        alt=""
        className="absolute hidden sm:block select-none animate-mandala-slow"
        style={{
          bottom: "-18vh",
          left: "-5vw",
          width: "clamp(240px, 24vw, 380px)",
          opacity: 0.18,
        }}
      />

      {/* Sacred Chakra - upper-right */}
      <img
        src={CHAKRA_URL}
        alt=""
        className="absolute hidden sm:block select-none animate-mandala-reverse"
        style={{
          top: "10vh",
          right: "-5vw",
          width: "clamp(220px, 22vw, 360px)",
          opacity: 0.2,
        }}
      />
    </div>
  );
};

export default PageBackground;
